export { default } from './StoresContainer';
